import React from 'react';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import FraudHitEvaluatorSearchParams from './FraudHitEvaluatorSearchParams';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import AntiFraudToolService from '../../../Services/AntiFraudToolService';
import EvaluatorService from '../../../Services/EvaluatorService';
import FraudToolBaseEvaluatorItem from '../../../Domain/FraudToolBaseEvaluatorItem';

export default class BaseEvaluatorTab extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    const searchParams = new FraudHitEvaluatorSearchParams();
    searchParams.FraudHitId = props.fraudHitId;

    this.state = {
      searchItem: searchParams,
      shownPanel: ShownPanelsEnum.None,
      selectedFraudHitEvaluator: null,
    };
  }

  componentDidMount() {}

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={FraudToolBaseEvaluatorItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={AntiFraudToolService.GetBaseEvaluator}
          convertDBItemsFunction={EvaluatorService.ConvertDBEvaluator}
          searchItem={this.state.searchItem}
          orderDirection={OrderDirectionsEnum.Desc}
          orderBy={'Id'}
          showSearchStrip={false}
          searchParamsType={FraudHitEvaluatorSearchParams}
          clickOnStartSearch={(searchItem) => this.setState({ searchItem: { ...searchItem } })}
          enableUrlPush={false}
          showPagination={false}
          errorCode='BET43'
        />
      </div>
    );
  }
}
